import IconButton from '@mui/material/IconButton';
import * as React from 'react';
import { CgSpinner } from 'react-icons/cg';
import { MdOutlineFileDownload } from 'react-icons/md';
import { toast } from 'react-toastify';

import { TrainingTypeEnum } from '@/constants/trainingTypeOptions';
import { ProcedureTrainingFilters } from '@/state/ProcedureTraining.atom';

import api from '../../services/apiSgft';
import LightTooltip from './LightTooltip';

interface ExtractTrainingMatrixButtonProps {
	filteredData: ProcedureTrainingFilters;
	isPositionFilteringIndicator: boolean;
	isTrainingFilteringIndicator: boolean;
	disabled?: boolean;
}

export const ExtractProcedureTrainingMatrixButton: React.FC<
	ExtractTrainingMatrixButtonProps
> = (props) => {
	const { filteredData } = props;
	const [loading, setLoading] = React.useState(false);
	const isDisabled = props.disabled ? props.disabled : loading;

	async function downloadMatrix() {
		setLoading(true);
		try {
			const response = await api.get(`extraction/procedure-training-matrix`, {
				params: {
					jobTitleIds: filteredData.jobTitleIds,
					trainingNames: filteredData.trainingNames,
					workStationsIds: filteredData.workStationIds,
					coordinationIds: filteredData.coordinationIds,
					mappingResponsibleIds: filteredData.mappingResponsibleIds,
					management: filteredData.management,
					locations: filteredData.locations,
					onlyUnmappedPositions: props.isPositionFilteringIndicator,
					onlyUnmappedTrainings: props.isTrainingFilteringIndicator,
				},
				responseType: 'blob',
			});
			const url = window.URL.createObjectURL(
				new Blob([response.data], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				}),
			);
			const link = document.createElement('a');

			const downloadFileName = `Matriz de Treinamentos ${TrainingTypeEnum.PROCEDURE}s.xlsx`;

			link.href = url;
			link.setAttribute('download', downloadFileName);
			document.body.appendChild(link);
			link.click();
			link.remove();
		} catch (e) {
			toast.error('Erro ao realizar extração', {
				theme: 'colored',
				toastId: 'error',
			});
			throw e;
		} finally {
			setLoading(false);
		}
	}

	const buttonWithTooltip = (
		<div className={!isDisabled ? 'cursor-pointer' : ''}>
			<LightTooltip title="Extrair matriz de treinamentos">
				<IconButton onClick={downloadMatrix} disabled={isDisabled}>
					{loading ? (
						<CgSpinner
							size={30}
							color="#c1c1c1"
							className="h-full animate-spin"
						/>
					) : (
						<MdOutlineFileDownload />
					)}
				</IconButton>
			</LightTooltip>
		</div>
	);

	const buttonWithoutTooltip = (
		<div className={!isDisabled ? 'cursor-pointer' : ''}>
			<IconButton disabled={isDisabled}>
				{loading ? (
					<CgSpinner
						size={30}
						color="#c1c1c1"
						className="h-full animate-spin"
					/>
				) : (
					<MdOutlineFileDownload />
				)}
			</IconButton>
		</div>
	);

	return <>{isDisabled ? buttonWithoutTooltip : buttonWithTooltip}</>;
};
